export default "__VITE_ASSET__0ki6n1Am__";